import PropTypes from 'prop-types';
import ImmutablePropTypes from 'immutable-prop-types';

const schemaDescriptionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  schemaId: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  humanDescription: PropTypes.string
});

const databaseDescriptionShape = PropTypes.arrayOf(
  PropTypes.shape({
    views: PropTypes.objectOf(
      PropTypes.shape({
        columns: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string
          })
        )
      })
    )
  })
);

const spaceShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
});

const userShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

const sourceShape = PropTypes.shape({
  id: PropTypes.string,
  displayName: PropTypes.string,
  name: PropTypes.string
});

const termTranslationShape = PropTypes.shape({
  termList: PropTypes.arrayOf(PropTypes.string),
  displayedDescription: PropTypes.string
});

const rowShape = PropTypes.shape({
  [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

const roleShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string
});

const headersShape = PropTypes.arrayOf(
  PropTypes.shape({
    colSpan: PropTypes.number,
    column: PropTypes.string.isRequired,
    component: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    width: PropTypes.string
  })
);

const rowsShape = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    fields: rowShape.isRequired
  })
);

const columnDefsShape = PropTypes.arrayOf(
  PropTypes.shape({
    headerName: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    cellRenderer: PropTypes.func
  })
);

const vegaSpecShape = PropTypes.shape({
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ text: PropTypes.string })]),
  layer: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.shape({}),
      y: PropTypes.shape({})
    })
  ),
  encoding: PropTypes.shape({
    x: PropTypes.shape({}),
    y: PropTypes.shape({})
  })
});

const dataShape = PropTypes.shape({
  rows: rowsShape,
  headers: headersShape
});

const answerShape = PropTypes.shape({
  body: PropTypes.string,
  data: dataShape,
  error: PropTypes.bool,
  formattingHints: PropTypes.objectOf(PropTypes.string),
  id: PropTypes.string,
  isCanned: PropTypes.bool,
  isError: PropTypes.bool,
  queryExplanation: PropTypes.string,
  rawSql: PropTypes.string,
  vegaSpec: vegaSpecShape
});

const baseQuestionFields = {
  answer: answerShape,
  appliedTermTranslationIds: PropTypes.arrayOf(PropTypes.string),
  assetTitle: PropTypes.string,
  body: PropTypes.string,
  exportFileName: PropTypes.string,
  id: PropTypes.string,
  isChart: PropTypes.bool,
  isHelpReceived: PropTypes.bool,
  isHelpRequested: PropTypes.func,
  schema: PropTypes.string,
  status: PropTypes.string,
  statusMessage: PropTypes.string,
  statusProgress: PropTypes.number,
  spaceIds: PropTypes.arrayOf(PropTypes.string),
  schemas: PropTypes.arrayOf(PropTypes.string)
  // Important: We skip lastChartFollowUp & followUps here
};

const lexicalBeautifulMentionsTag = PropTypes.shape({
  value: PropTypes.string.isRequired,
  description: PropTypes.string
});

const questionShape = PropTypes.shape(baseQuestionFields);

const organizationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  description: PropTypes.string,
  category: PropTypes.string,
  legalId: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  updatedBy: PropTypes.string,
  deletedAt: PropTypes.string
});

baseQuestionFields.followUps = ImmutablePropTypes.list;
baseQuestionFields.lastChartFollowUp = questionShape;

export {
  answerShape,
  organizationShape,
  columnDefsShape,
  dataShape,
  headersShape,
  questionShape,
  rowShape,
  rowsShape,
  sourceShape,
  spaceShape,
  schemaDescriptionShape,
  termTranslationShape,
  userShape,
  vegaSpecShape,
  roleShape,
  databaseDescriptionShape,
  lexicalBeautifulMentionsTag
};
